export default "/images/ic-credit.svg?0c81ab46c41df13364a55c7fff9841f2";